module.exports = __webpack_public_path__ + "img/alipay.f94b5224.png";